const languageToDatoLocale = {
  en: 'en',
  cs: 'cs',
  da: 'da',
  nl: 'nl',
  fi: 'fi',
  fr: 'fr',
  de: 'de',
  it: 'it',
  no: 'no',
  pl: 'pl',
  ru: 'ru',
  sv: 'sv',
  es: 'es',
  pt: 'pt_BR',
  'pt-pt': 'pt_PT',
} as const

export default languageToDatoLocale

export const datoLocaleToLanguage = {
  en: 'en',
  cs: 'cs',
  da: 'da',
  nl: 'nl',
  fi: 'fi',
  fr: 'fr',
  de: 'de',
  it: 'it',
  no: 'no',
  pl: 'pl',
  ru: 'ru',
  sv: 'sv',
  es: 'es',
  pt_BR: 'pt',
  pt_PT: 'pt-pt',
} as const
